<template>
  <v-card class="pa-4" elevation="0">
    <v-card-title class="text-h6 font-weight-light pl-0">
      {{ $t("profile.userInformationCard.personalInformation") }}
    </v-card-title>
    <v-form class="mb-0" v-model="validForm" :disabled="!valid">
      <v-row>
        <v-col cols="12" lg="7">
          <v-text-field
            :label="$t('profile.userInformationCard.name')"
            v-model="name"
            :rules="nameRules"
            outlined
          ></v-text-field>
          <v-text-field
            :label="$t('profile.userInformationCard.email')"
            v-model="email"
            :rules="emailRules"
            outlined
          ></v-text-field>
          <v-text-field
            :label="$t('profile.userInformationCard.phone')"
            v-model="phone"
            :rules="phoneRules"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="5" class="d-flex justify-end align-end">
          <v-btn
            class="text-case-normal px-6 my-lg-3 edit-button"
            :disabled="!valid || !validForm"
            @click="updateUser"
          >
            {{ $t("profile.userInformationCard.saveChanges") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import * as Sentry from "@sentry/vue";
import user from "@/api/user.js";
export default {
  name: "UserInformationCard",
  props: ["valid"],
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      validForm: true,
      nameRules: [
        (v) => !!v || this.$t("profile.userInformationCard.nameRequired"),
        (v) =>
          (v && v.length >= 5) ||
          this.$t("profile.userInformationCard.nameMinLength"),
      ],
      emailRules: [
        (v) => !!v || this.$t("profile.userInformationCard.emailRequired"),
        (v) =>
          /.+@.+\..+/.test(v) ||
          this.$t("profile.userInformationCard.emailInvalid"),
      ],
      phoneRules: [
        (v) => !!v || this.$t("profile.userInformationCard.phoneRequired"),
      ],
    };
  },
  methods: {
    async updateUser() {
      try {
        const data = {
          email: this.email,
          entry_date: this.$store.getters.getUser.entry_date,
          job_title: this.$store.getters.getUser.job_title,
          name: this.name,
          phone: this.phone,
          role: this.$store.getters.getUser.role,
          department: this.$store.getters.getUser.department,
        };
        this.validForm = false;

        const response = await user.updateUser(data);
        if (response.code === 200) {
          let dataAlert = {
            message: this.$t("profile.userInformationCard.profileUpdated"),
            status: "success",
          };
          this.$emit("alert", dataAlert);
          await this.$store.dispatch("authenticateAndLoadUser", false);
        } else {
          let dataAlert = {
            message:
              response.message ||
              this.$t("profile.userInformationCard.updateFailed"),
            status: "error",
          };
          this.$emit("alert", dataAlert);
        }
      } catch (error) {
        Sentry.captureException(error);
        let dataAlert = {
          message: this.$t("profile.userInformationCard.updateFailed"),
          status: "error",
        };
        this.$emit("alert", dataAlert);
      } finally {
        this.validForm = true;
      }
    },
    syncFromStore() {
      const user = this.$store.getters.getUser;
      if (!user || !user.email) {
        return;
      }
      this.name = user.name;
      this.email = user.email;
      this.phone = user.phone;
    },
  },
  mounted() {
    this.syncFromStore();
  },
  activated() {
    this.syncFromStore();
  },
};
</script>
